"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toShortMoney = exports.formatBalanceWithoutDecimals = exports.convertToBalanceWithDecimal = exports.balanceWithDecimal = exports.simpleFormatBalance = void 0;
const util_1 = require("@polkadot/util");
const bn_js_1 = __importDefault(require("bn.js"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const simpleFormatBalance = (balance, decimals, currency, withUnit = true) => {
    const { unit, decimals: defaultDecimals } = util_1.formatBalance.getDefaults();
    return (0, util_1.formatBalance)(balance, { decimals: decimals || defaultDecimals, forceUnit: currency || unit, withUnit });
};
exports.simpleFormatBalance = simpleFormatBalance;
const TEN_BN = new bignumber_js_1.default(10);
/** Add decimals to the balance. Example balanceWithDecimal(5, 10) // 50000000000 */
const balanceWithDecimal = (balance, decimal) => new bignumber_js_1.default(balance).multipliedBy(TEN_BN.pow(new bignumber_js_1.default(decimal)));
exports.balanceWithDecimal = balanceWithDecimal;
/** Extract decimals from the balance. Example convertToBalanceWithDecimal("50000000000", 10) // 5 */
const convertToBalanceWithDecimal = (balance, decimal) => new bignumber_js_1.default(balance).dividedBy(TEN_BN.pow(new bignumber_js_1.default(decimal)));
exports.convertToBalanceWithDecimal = convertToBalanceWithDecimal;
const formatBalanceWithoutDecimals = (balance, symbol) => `${(0, util_1.formatNumber)(new bn_js_1.default(balance.toString()))} ${symbol}`;
exports.formatBalanceWithoutDecimals = formatBalanceWithoutDecimals;
function moneyToString({ num, prefix = '', suffix, fractions = 2 }) {
    const _fractions = num < 1 ? fractions : 1;
    const suffixPart = suffix ? ' ' + suffix : '';
    return `${prefix}${num.toFixed(_fractions)}${suffixPart}`;
}
const num1K = 1000;
const num1M = Math.pow(num1K, 2);
const num1B = Math.pow(num1K, 3);
const num1T = Math.pow(num1K, 4);
function toShortMoney(_a) {
    var { num } = _a, props = __rest(_a, ["num"]);
    if (num >= num1K && num < num1M) {
        return moneyToString(Object.assign({ num: num / num1K }, props)) + 'K';
    }
    else if (num >= num1M && num < num1B) {
        return moneyToString(Object.assign({ num: num / num1M }, props)) + 'M';
    }
    else if (num >= num1B && num < num1T) {
        return moneyToString(Object.assign({ num: num / num1B }, props)) + 'B';
    }
    return moneyToString(Object.assign({ num }, props));
}
exports.toShortMoney = toShortMoney;
